import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/builders/builderstone.png";
import SubStone from "../components/Health/SubStone";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/builders/builders1.webp";
import Img2 from "../Assets/builders/builders2.webp";
import Img3 from "../Assets/builders/builders3.webp";
import Img4 from "../Assets/builders/builders4.webp";
import Img5 from "../Assets/builders/builders5.webp";
import Img6 from "../Assets/builders/builders6.webp";
import Img7 from "../Assets/builders/builders7.webp";
import Img8 from "../Assets/builders/builders8.webp";
import Img9 from "../Assets/builders/builders9.webp";
import Img10 from "../Assets/builders/builders10.webp";
import Img11 from "../Assets/builders/builders11.webp";
import LeaderBuildWithUs from "../components/Leadership/LeaderBuildWithUs";
import SubJoinSection from "../components/Health/SubJoinSection";
import doctorImage from "../Assets/builders/Group 1597883420.png";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import hospitalImg from "../Assets/builders/builder-carousel1.png";
import diagnosticsImg from "../Assets/builders/builder-carousel2.png";
import instituteImg from "../Assets/builders/builder-carousel3.png";
import pharmacyImg from "../Assets/builders/builder-carousel4.png";
import healthparksImg from "../Assets/builders/builder-carousel5.png";
import builderheart from "../Assets/builders/builderheart.png";
import builderpeople from "../Assets/builders/builderpeople.png"
import pulseLine from "../Assets/tech/pulse.png";
import BuildersClientsCollaborations from "../components/Builders/BuildersClientsCollaborations";
import doctorImage1 from "../Assets/tech/doctorImage1.png"
import founderPhoto from "../Assets/builders/builderfounder.png"
import SubFounder from "../components/Health/SubFounder"
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import BuildersBuildWithUs from "../components/Builders/BuildersBuildWithUs";
import TechBanner from "../components/Tech/TechBanner"
import banner from "../Assets/builders/Builders.jpg"
import BuildBanner from "../components/Foundation/BuildBanner";
import TestimonialSlider from "../components/Health/TestimonialSlider";
import testimonialbg from "../Assets//rock-bg.png"

const Builders = () => {
  const meta = seoMeta["/Builders"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
          
const paragraphs = [
  `VCNR Builders & Infrastructure provides end-to-end building and development solutions across residential, commercial, industrial, and public infrastructure. From elegant homes to large-scale logistics parks, we don’t just construct buildings — we build what the future envisions.`,
  
  `With a strong foundation in Nelamangala and ongoing projects across Karnataka, we’re now expanding into key southern cities while setting our sights on pan-India growth. Our five-year roadmap is global — focused on urban expansion, industrial development, and sustainable smart infrastructure.`,
];

const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
const paragraphs2 = [
  `As one of the top 10 builders in Bangalore, VCNR Builders delivers turnkey solutions across residential, commercial, industrial, and public infrastructure. Recognized among leading construction companies in India, we combine innovative design, engineering expertise, and social purpose to build environments that truly make a difference.`
]
  const healthcareCards = [
  { title: "Industrial Floor Polishing & Finishing Works", image: Img1 },
  { title: "Surface Leveling & Concrete Smoothing", image: Img2 },
  { title: "Pre-Engineered Building (PEB) Roof Installation", image: Img3 },
  { title: "Metal Roofing Sheet Installation", image: Img4 },
  { title: "Steel Structure Framework for Industrial Sheds", image: Img5 },
  { title: "Pre-Engineered Building (PEB) Structural Assembly", image: Img6 },
  { title: "Pre-Engineered Building (PEB) Interior Structure", image: Img7 },
  { title: "Steel Reinforcement for Concrete Slab", image: Img8 },
  { title: "Steel Mesh Reinforcement Work", image: Img9 },
    { title: "Rebar Framework for Structural Flooring", image: Img10 },
  { title: "Modern Industrial/Commercial Building Exterior", image: Img11 },
];
const quickAccessCards = [
  {
    title: "Step Into Opportunity\nGet the Brochure",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Turn Connections\ninto Commissions",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Connecting Talent\nwith Opportunity",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Stay Ahead. Get Hired.\nOn WhatsApp",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Residential Developments",
    description: "Among the most trusted home construction companies in Bangalore, we design and build sustainable homes with modern layouts, energy efficient materials, and smart space planning that is perfect for families looking to invest in future living.",
    image: hospitalImg,
  },
  {
    title: "Healthcare & Institutional Builds",
    description: "As a civil construction company, we deliver healthcare facilities, hospitals, schools, and public institutions with functional designs, patient-friendly layouts, and long-term operational efficiency.",
    image: diagnosticsImg,
  },
  {
    title: "Commercial & Industrial Spaces",
    description: "We are a trusted name as commercial and industrial construction in Bangalore, delivering tech parks, factories, and retail hubs. Our team is also experienced in pre-engineering solutions to reduce costs and construction time while maintaining quality.",
    image: instituteImg,
  },
  {
    title: "Urban Infrastructure",
    description: "With a strong track record as a civil construction company in Bangalore, we execute city-scale projects including roads, public utilities, drainage systems, and civic infrastructure that strengthen urban resilience",
    image: pharmacyImg,
  },
  {
    title: "Mixed-Use Complexes",
    description: "As a forward looking construction company in Bengaluru, we build integrated lifestyle hubs that combine residential, commercial, and recreational spaces designed for convenience",
    image: healthparksImg,
  },
  {
    title: "Urban Infrastructure",
    description: "With a strong track record as a civil construction company in Bangalore, we execute city-scale projects including roads, public utilities, drainage systems, and civic infrastructure that strengthen urban resilience",
    image: pharmacyImg,
  },
  {
    title: "Mixed-Use Complexes",
    description: "As a forward looking construction company in Bengaluru, we build integrated lifestyle hubs that combine residential, commercial, and recreational spaces designed for convenience",
    image: healthparksImg,
  },

];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
      <BuildBanner />
      {/* <TechBanner
  backgroundImage={banner}
  bannerHeading="Leading Construction Company in Bangalore"
  subText="At VCNR Builders & Infrastructure, we believe construction is more than a concrete and steel, it is about uplifting dreams and leave a lasting impression"
  buttonText="Explore More"
  buttonLink="https://vcnr.com/"
/> */}
<SubStory
      title="Builders Story"
      subtitle="Where the Journey Started"
      paragraphs={paragraphs}
    />
    <SubStone
  imageSrc={bgImage}
  heading={<>Every beam we raise<br /> carries a responsibility to<br /> people, place, and planet.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/aboutVCNR"}
/>
<ParallaxSection><SubStory
      title={<>Our Focus Areas</>}
      paragraphs={paragraphs2}
    /></ParallaxSection>
<ParallaxSection><Subservicesmediacarousel
      // title="Core Offerings"
      subtitle="The VCNR Tech Stack: Designed to Drive Change<br />
Through Purposeful Mobile and Web Development"
      services={servicesData}
    /></ParallaxSection>
    <ParallaxSection><OutreachSection
          title="Our Architect Portfolio"
          // subheading="Extending Care Beyond Walls Through Hospitals, Health Parks, and a Seamless Hospital Integrated System."
          // description={[
          //   "At VCNR, we believe care doesn’t stop at the hospital doors only. Through our expanding network of hospitals, new medical centers, health parks, and accessible health plans, our hospital integrated system ensures quality care reaches every corner of the community.",
          //   "Our community health programs go even further, bringing care to the doorstep of those who need it most. We conduct frequent rural health camps, school-based preventive screenings, elderly wellness drives, and even provide life-saving surgeries for underprivileged patients. No matter where someone lives, VCNR is committed to being their partner in health."
          // ]}
          cardsData={healthcareCards}
          buttonText="View Project Portfolio"
          onButtonClick={() => window.alert("Volunteer form will open")}
        /></ParallaxSection>
<ParallaxSection><BuildersClientsCollaborations /></ParallaxSection>
<ParallaxSection><SubJoinSection
  image={doctorImage}
  title={<>Execution Strength</>}
    subtitle=""

  description={<>
    . In-house teams across design, engineering, project management<br />
    . Proven SOPs and quality systems<br /> . Reliable vendor and partner ecosystem<br />. On-ground agility with scale-ready processes
  </>}

  secondaryText="At VCNR, we see construction as a service, We honor. Our commitment remains steady, whether we're building a family home or a logistics hub."
  subtitle1={<>Build with purpose. Deliver with precision.</>}

/></ParallaxSection>
<ParallaxSection><SubFounder
      founderImage={founderPhoto}
      heading={<>Tech & Safety<br />Expert Teams.<br /> Unwavering Safety."</>}
      // name="Stories of Strength and Healing"
      messages={[
        "Our people are our strength. At VCNR Builders, every project is powered by skilled engineers, architects, and site teams who bring both experience and heart to the job. With tools like BIM, drone surveys, and predictive scheduling, we stay ahead delivering on time, on spec, and with intention.",
        "And when it comes to safety, we don’t compromise. It is built into every blueprint, site boundary, and daily routine. Our zero injury goal is not just a standard it is a promise. Every team member is trained to meet the highest global safety practices because we believe people come first always.",
      ]}
      subname="True design is invisible it leaves behind a sustainable legacy, not a footprint."
      buttonText="Meet Our Engineers"
buttonLink="/Leadership"
    /></ParallaxSection>
    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
    <h2 style={{ fontSize: '3rem', fontWeight: 300, margin: 0, textUnderlineOffset: '8px', color: '#fff', lineHeight: 1 }}>
      Reviews & Testimonials
    </h2>
    <h3 style={{ fontSize: '1.5rem', fontWeight: 300, margin: '1.2rem 0 0.5rem 0', color: '#fff', lineHeight: 1 }}>
      Stories of Transformation
    </h3>
    <p style={{ color: '#fff', fontSize: '1.15rem', maxWidth: 900, margin: '0 auto', marginBottom: '1.5rem', lineHeight: 1.4 }}>
      Meet the people behind the numbers. From a young girl now pursuing medical school to a farmer doubling his yield through our training, these are stories of courage, community, and collective growth
    </p>
  </div>
    <TestimonialSlider
    testimonials={aboutTestimonials}
    backgroundImage={testimonialbg}
  /> 

        <ParallaxSection><BuildersBuildWithUs /></ParallaxSection>
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection>
          
          

    </>
  );
};

export default Builders;
